import { IaUSTData, IaUSTProfit, ICryptoPrices } from './../../../models/Crypto';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../abstraction/auth.service';
import { CryptoService } from '../../../abstraction/crypto.service';
import { DataLayerService } from '../../../services/utils/data-layer.service';
import { MatDialog } from '@angular/material/dialog';
import { FiatInvestmentPopupComponent } from './fiat-investment-popup/fiat-investment-popup.component';
import { Utils } from '../../../utils/Utils';
import { AuthUtilsService } from 'src/app/pages/auth/utils/auth-utils.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main-balance',
  templateUrl: './main-balance.component.html',
  styleUrls: ['./main-balance.component.scss'],
})
export class MainBalanceComponent implements OnInit, OnDestroy {
  @Input() selectedTab;
  @Output() switchTab: EventEmitter<string> = new EventEmitter();
  cotizacionHardcodeada: any;
  cryptoBalanceInUsd: number;
  cryptoBalanceInArs: number;
  selectedCoin = '';
  fiatInvestmentPopupIsOpened = false;
  austProfits: IaUSTProfit;
  balanceUsd: number;
  balanceSubscription: Subscription;
  constructor(
    public dataS: DataLayerService,
    public authService: AuthService,
    public cryptoService: CryptoService,
    public dialog: MatDialog,
    public utils: AuthUtilsService,
  ) {}

  ngOnInit(): void {
    this.cryptoService.prices.subscribe((prices: ICryptoPrices) => {
      this.cryptoBalanceInUsd = 0;
      this.cryptoBalanceInArs = 0;
      const portfolio = this.authService.loggedUser?.balance.crypto;
      const bundles = this.authService.loggedUser?.balance?.bundle?.ARS;

      if (portfolio) {
        const portfolioCoins = Object.keys(portfolio);

        let totalUsd = 0;
        let totalArs = 0;
        if (Object.keys(prices).length !== 0) {
          portfolioCoins.forEach((coin) => {
            let coinTicker = coin;
            if (coinTicker === 'LUNA') {
              coinTicker = 'LUNC';
            }
            const priceObj = prices[coinTicker + '_USD'];
            const priceArsObj = prices[coinTicker + '_ARS'];
            if (priceObj) {
              if (coinTicker === 'AUST') {
                totalUsd += portfolio[coin].amount * +prices.AUST_DAI.sell * +prices.DAI_USD.sell;
              } else {
                totalUsd += portfolio[coin].amount * +prices[coinTicker + '_USD'].sell;
              }
            }
            if (priceArsObj) {
              if (coinTicker === 'AUST') {
                totalArs += portfolio[coin].amount * +prices.AUST_DAI.sell * +prices.DAI_ARS.sell;
              } else {
                totalArs += portfolio[coin].amount * +prices[coinTicker + '_ARS'].sell;
              }
            }
          });
          this.cryptoBalanceInUsd += totalUsd;
          this.cryptoBalanceInArs += totalArs;
        }
      }
      if (bundles) {
        const bundleCoins = Object.keys(bundles);
        let totalUsd = 0;
        let totalArs = 0;
        if (Object.keys(prices).length !== 0) {
          bundleCoins.forEach((coin) => {
            totalArs += this.cryptoService.getFiatValueByBundle(coin, 'ARS');
            totalUsd += this.cryptoService.getFiatValueByBundle(coin, 'USD');
          });
          this.cryptoBalanceInUsd += totalUsd;
          this.cryptoBalanceInArs += totalArs;
        }
      }
    });

    this.cotizacionHardcodeada = {
      USDC: 141.1,
      DAI: 141.3,
      WEEZ: 0,
    };
    this.balanceSubscription = this.authService.loggedUserObs.subscribe((user) => {
      this.setBalanceUsd(user?.balance?.fiat.USD);
    });
  }

  ngOnDestroy(): void {
    this.balanceSubscription.unsubscribe();
  }

  getCryptoStakedAmount() {
    let totalStaked = 0;
    const balances = this.cryptoService.cryptoBalance.value;
    if (balances) {
      for (const [key, value] of Object.entries(balances)) {
        totalStaked += value.stakeBalance;
      }
    }
    return totalStaked;
  }

  getCryptoBalance() {
    return this.cryptoService.getTotalCryptoBalance()[0];
  }

  openFiatInvestmentPopup(currency: string) {
    // this.fiatInvestmentPopupIsOpened = true;
    // this.selectedCoin = currency;
  }

  onCloseModal() {
    this.fiatInvestmentPopupIsOpened = false;
  }

  setBalanceUsd(num) {
    this.balanceUsd = Utils.roundDown(num);
  }
}
